import React from 'react';
import { Form, Button, Radio, Input } from 'antd';
import * as actions from '../../../store/actions/InterviewActions';
import { setSubmittedBy } from '../../../store/actions';
import { connect } from 'react-redux';
import { history } from '../../../index';

import styles from './FeedbackForm.scss';

class FeedbackForm extends React.Component {
  formRef = React.createRef();
  state = {
    isFormValid: false,
  };

  showSurveyCompletePage = async () => {
    await this.props.setSubmittedBy('interviewer');
    const interview_id = localStorage.getItem('interview_id');
    history.push(`/survey/interview/${interview_id}`);
  };

  handleFinish = values => {
    const data = {
      rating: values.rating,
      feedback: values.feedback,
    };
    this.props.submitFeedback(data, this.showSurveyCompletePage);
  };

  handleFormChange = (_, allFields) => {
    const isValid = allFields.every(
      field => field.errors.length === 0 && field.value !== undefined && field.value !== '',
    );
    this.setState({ isFormValid: isValid });
  };

  render() {
    return (
      <Form
        className={styles.form}
        ref={this.formRef}
        layout="vertical"
        onFinish={this.handleFinish}
        onFieldsChange={this.handleFormChange}
      >
        <Form.Item
          name="rating"
          label="Rating"
          className={styles['form-rating']}
          rules={[{ required: true, message: 'Please select a rating' }]}
        >
          <Radio.Group>
            <Radio value={1}>Never Hire</Radio>
            <Radio value={2}>Not Inclined to Hire</Radio>
            <Radio value={3}>Maybe</Radio>
            <Radio value={4}>Inclined to hire</Radio>
            <Radio value={5}>Strong Hire</Radio>
          </Radio.Group>
        </Form.Item>

        <Form.Item
          name="feedback"
          label="Feedback"
          className={styles['form-feedback']}
          rules={[{ required: true, message: 'Please provide feedback' }]}
        >
          <Input.TextArea className={styles['form-feedback__textarea']} />
        </Form.Item>

        <Form.Item className={styles['form-button']}>
          <Button
            type="primary"
            htmlType="submit"
            disabled={!this.state.isFormValid}
          >
            Submit
          </Button>
        </Form.Item>
      </Form>
    );
  }
}

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => ({
  submitFeedback: (data, callback) => dispatch(actions.submitFeedback(data, callback)),
  setSubmittedBy: value => dispatch(setSubmittedBy(value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FeedbackForm);
